import { ActionEnum, AlertMessage } from '../../common'

export const SET_ACTION = 'SET_ACTION'
export const SET_ACTION_PROCESSING = 'SET_ACTION_PROCESSING'
export const SET_SHOW_MANAGE_MODAL = 'SET_SHOW_MANAGE_MODAL'
export const SET_SHOW_SEARCH_DRAWER = 'SET_SHOW_SEARCH_DRAWER'
export const SET_SHOW_RESET_PASSWORD_MODAL = 'SET_SHOW_RESET_PASSWORD_MODAL'
export const SET_ALERT_MESSAGE = 'SET_ALERT_MESSAGE'

export interface CommonState {
  management: {
    action: ActionEnum
    actionProcessing: boolean
    showManageModal: boolean
    showSearchDrawer: boolean
    showResetPasswordModal: boolean
    alertMessage?: AlertMessage
  }
  regex: {
    phone: RegExp
    identityCardNumber: RegExp
  }
}

interface SetActionAction {
  type: typeof SET_ACTION
  payload: ActionEnum
}

interface SetActionProcessingAction {
  type: typeof SET_ACTION_PROCESSING
  payload: boolean
}

interface SetShowManageModalAction {
  type: typeof SET_SHOW_MANAGE_MODAL
  payload: boolean
}

interface SetShowSearchDrawerAction {
  type: typeof SET_SHOW_SEARCH_DRAWER
  payload: boolean
}

interface SetAlertMessageAction {
  type: typeof SET_ALERT_MESSAGE
  payload?: AlertMessage
}

interface SetShowResetPasswordModalAction {
  type: typeof SET_SHOW_RESET_PASSWORD_MODAL
  payload: boolean
}

export type CommonAction =
  | SetActionAction
  | SetActionProcessingAction
  | SetShowManageModalAction
  | SetShowSearchDrawerAction
  | SetAlertMessageAction
  | SetShowResetPasswordModalAction
